/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RecurrenceDaySlotResponse
 */
export interface RecurrenceDaySlotResponse {
    /**
     * Day of week (0=Sunday, 6=Saturday)
     * @type {number}
     * @memberof RecurrenceDaySlotResponse
     */
    dayOfWeek: number;
    /**
     * 24-hour time, "HH:mm" — this day's own start time
     * @type {string}
     * @memberof RecurrenceDaySlotResponse
     */
    startTimeOfDay: string;
}

/**
 * Check if a given object implements the RecurrenceDaySlotResponse interface.
 */
export function instanceOfRecurrenceDaySlotResponse(value: object): value is RecurrenceDaySlotResponse {
    if (!('dayOfWeek' in value) || value['dayOfWeek'] === undefined) return false;
    if (!('startTimeOfDay' in value) || value['startTimeOfDay'] === undefined) return false;
    return true;
}

export function RecurrenceDaySlotResponseFromJSON(json: any): RecurrenceDaySlotResponse {
    return RecurrenceDaySlotResponseFromJSONTyped(json, false);
}

export function RecurrenceDaySlotResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecurrenceDaySlotResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'dayOfWeek': json['dayOfWeek'],
        'startTimeOfDay': json['startTimeOfDay'],
    };
}

export function RecurrenceDaySlotResponseToJSON(json: any): RecurrenceDaySlotResponse {
    return RecurrenceDaySlotResponseToJSONTyped(json, false);
}

export function RecurrenceDaySlotResponseToJSONTyped(value?: RecurrenceDaySlotResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dayOfWeek': value['dayOfWeek'],
        'startTimeOfDay': value['startTimeOfDay'],
    };
}

